import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Team route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object containing
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} TeamRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/team",
        name: "Team",
        meta: {
            title: "Team",
            modules: ["users"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN]
        },
        component: () =>
            import(/* webpackChunkName: "teams" */ "@/modules/teams/pages/Team")
    },
    {
        path: "/team/new",
        name: "NewMember",
        meta: {
            title: "New Member",
            modules: ["users"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN]
        },
        component: () =>
            import(/* webpackChunkName: "teams" */ "@/modules/teams/pages/NewMember")
    },
    {
        path: `/team/${idParam()}`,
        name: "MemberProfile",
        meta: {
            title: "Member Profile",
            modules: ["users"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN]
        },
        component: () =>
            import(/* webpackChunkName: "teams" */ "@/modules/teams/pages/MemberProfile")
    }
]